"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitAmountConfirm = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var ui_1 = require("./ui");
var ChangeDirectDebitAmountConfirm = function () {
    var _a;
    var Redirect = (0, core_1.useComponents)().Redirect;
    var payments = (0, core_1.useLinks)().payments;
    var search = window.location.search;
    var amount = (0, core_1.getValueFromQueryParams)('amount', search);
    var upcomingPaymentAmount = (0, core_1.getValueFromQueryParams)('upcomingPaymentAmount', search) || undefined;
    var upcomingPaymentDate = (0, core_1.getValueFromQueryParams)('upcomingPaymentDate', search) || undefined;
    var futureUpcomingPaymentDate = (0, core_1.getValueFromQueryParams)('futureUpcomingPaymentDate', search) || undefined;
    var scheduleDay = (0, core_1.getValueFromQueryParams)('scheduleDay', search);
    if (!amount) {
        return react_1.default.createElement(Redirect, { to: payments() });
    }
    var data = scheduleDay
        ? { amount: amount, scheduleDay: scheduleDay }
        : {
            amount: amount,
            upcomingPaymentAmount: upcomingPaymentAmount,
            upcomingPaymentDate: upcomingPaymentDate,
            futureUpcomingPaymentDate: futureUpcomingPaymentDate,
        };
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.CHANGE_DD_AMOUNT_CONFIRM, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(ui_1.ChangeDirectDebitAmountConfirmUI, __assign({}, data))));
};
exports.ChangeDirectDebitAmountConfirm = ChangeDirectDebitAmountConfirm;
